var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-header',[_c('app-header',{key:_vm.headerKey})],1),_vm._v(" "),_c('el-container',[_c('el-main',[_c('router-view')],1)],1),_vm._v(" "),_c('el-footer',[_c('app-footer')],1),_vm._v(" "),_c('time-log-form-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dff203e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/Layout.vue
// module id = MYYB
// module chunks = 1